var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserinline = function SvgUserinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user",
    clipPath: "url(#clip0_2365_22694)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0Zm0 6a6 6 0 1 1 0 12 6 6 0 0 1 0-12Zm0 22c-3.92 0-7.388-1.888-9.578-4.794A5.935 5.935 0 0 1 10 22h12c1.346 0 2.58.456 3.578 1.206C23.388 26.112 19.92 28 16 28Z",
    fill: "#F12B3B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2365_22694"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgUserinline;